import { styled } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

export const StyledProgressBar = styled("div")(
  (props: { value: number; theme: Theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    position: "relative",
    "& span": {
      fontFamily: "Lato",
      color: "#00A3A3",
      fontWeight: 600,
      fontSize: props.theme.typography.pxToRem(14),
    },
    "& .progressContainer": {
      marginLeft: props.value > 90 ? "-30px" : "0px",
      width: "88%",
      position: "relative",
      "& svg": {
        top: "17px",
        position: "absolute",
        left: `${props.value - 1}%`,
      },
    },
    "& .progressBar": {
      margin: "30px 0px 30px 0px",
      height: "12px",
      backgroundColor: "#D3F7F1",
      borderRadius: "100px",
      "& .MuiLinearProgress-barColorPrimary": {
        backgroundColor: "#22D9BB",
        borderRadius: "100px",
      },
    },
  })
);
